import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AtlasResource, AtlasTableColumnSchema, AtlasTableResource, PollyAtlasList } from '../@core/interfaces';

@Injectable({
  providedIn: 'root',
})
export class PollyAtlasStateManagerService {
  public currentAtlasInfo$: BehaviorSubject<AtlasResource | null> = new BehaviorSubject<AtlasResource | null>(null);
  public currentAtlasList$: BehaviorSubject<PollyAtlasList> = new BehaviorSubject<PollyAtlasList>({ data: [] }); // Empty array of atlases by default
  public tableColumnsList$: Subject<AtlasTableColumnSchema[]> = new Subject<AtlasTableColumnSchema[]>();
  public atlasTableList$: BehaviorSubject<AtlasTableResource[] | null> = new BehaviorSubject<AtlasTableResource[] | null>(null);
  public toggleTableOverviewSection$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public currentUserPermissionRevoked$: Subject<void> = new Subject<void>();
}
